module.exports = __webpack_public_path__ + "media/images/recruitment-8428539fe2b0d25e88a20de7b273628a.png";